import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Stack,
  ErrorIcon,
  Typography,
} from '@gogame/components';

const General = ({ data, onOpenPartnerCompany }) => {
  return (
    <DescriptionList disableGutters={true} data={data}>
      <DescriptionItem
        onValueClick={onOpenPartnerCompany}
        label={'Partner company'}
        type={'link'}
        field={'partnerCompany'}
        linkLabelField={'name'}
      />
      <DescriptionItem label={'Customer company'} field={'customerCompany'} />
      <DescriptionItem label={'Invoice level'} field={'invoiceLevel'} />
      <DescriptionItem label={'IO type'} field={'ioType'} />
      <DescriptionItem label={'VAT number'} field={'vatNumber'} />
      <DescriptionItem label={'TAX id'} field={'taxId'} />
      <DescriptionItem label={'Currency'} field={'currency'} />
      <DescriptionItem label={'Expense types'} field={'expenseTypes'} />
      <DescriptionItem label={'Network'} field={'network'} />
      <DescriptionItem label={'Payment term'} field={'paymentTerm'} />
      <DescriptionItem
        label={'DPA'}
        type={'dateRange'}
        field={'dpaPeriod'}
        template={'LL'}
        timeZone={'utc'}
        placeholder={
          <Stack alignItems={'center'} spacing={1} direction={'row'}>
            <Typography>No valid DPA</Typography>
            <ErrorIcon
              color={'error'}
              fontSize={'small'}
              sx={{ fontSize: 16 }}
            />
          </Stack>
        }
      />
      <DescriptionItem
        label={'Keywords in email subject'}
        field={'invoiceProcessingRuleKeywords'}
      />
      <DescriptionItem
        label={'Invoice sender domain'}
        field={'invoiceProcessingRuleSenderDomain'}
      />
    </DescriptionList>
  );
};

export default General;
